/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "OrderCancellationStatus": {
                "fields": {
                  "status": {
                    "type": "squareup.solidshop.model.OrderCancellationStatus.ReceptionStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReceptionStatus": {
                    "values": {
                      "NOT_REQUESTED": 1,
                      "PENDING": 2,
                      "FAILED": 3,
                      "SUCCESSFUL": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE OrderCancellationStatus @ squareup/solidshop/model/order_cancellation_status.proto at 10:1
 */
export const OrderCancellationStatus = $root.lookupType('squareup.solidshop.model.OrderCancellationStatus');
fixType(OrderCancellationStatus);
Builder.createAndAttachToType(OrderCancellationStatus);
/**
 * SOURCE ReceptionStatus @ squareup/solidshop/model/order_cancellation_status.proto at 11:5
 */
OrderCancellationStatus.ReceptionStatus = $root.lookupEnum('squareup.solidshop.model.OrderCancellationStatus.ReceptionStatus').values;
